@import 'fluid-select.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-select {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @select-tokens: @select-tokens-legacy;
      @select();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @select-tokens: @select-tokens-lm;
      @select();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @select-tokens: @select-tokens-corp;
      @select();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @select-tokens: @select-tokens-portal;
      @select();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@select: {

  // ==== Computed Variables

  @select-button-offset: @form-field-button-offset + @border-width;
  @select-padding-right: (@form-field-padding-right - @select-button-offset - @border-width) + @form-field-button-size;
  @select-padding-y: .form-field-padding-y(
    @font-size: @font-size;
    @line-height: @line-height;
  );

  font-family: @font-family;
  font-size: @font-size;
  line-height: @line-height;

  .form-group {
    .fluid-form-group();

    .input-wrapper {
      position: relative;

      .dropdown-icon,
      .cancel {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      .dropdown-icon {
        width: @form-field-button-size;
        height: @form-field-button-size;
        display: flex;
        justify-content: center;
        align-items: center;
        right: @select-button-offset;
        pointer-events: none;
        color: @color-text; // Sets FLUID Icon "fill" color
      }

      .cancel {
        right: @select-button-offset + @form-field-button-size;
      }

      select {
        .fluid-input(@select-tokens);
        height: @form-field-height; // Temporary fix for Safari (until refactor)
        appearance: none;
        text-indent: unset; // Temporary override of .fluid-input() default
        @select-padding-y();
        padding-left: @form-field-padding-left;
        padding-right: @select-padding-right;
        line-height: inherit;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        box-shadow: @select-tokens[box-shadow];
        transition: unset; // Temporary override of .fluid-input() default

        &:disabled {
          opacity: 1;
        }

        &.has-value {
          &.allow-cancel{
            padding-right: @select-padding-right + @form-field-button-size;
          }
        }

        // == Placeholder Text

        &:not(.has-value) {
          @placeholder();
          @select-transition();
        }

        // Transition styles need to be applied AFTER all others (until refactored)
        @select-transition();
      }

      select:hover:not(.readonly):not(.disabled),
      select:focus:not(.readonly):not(.disabled) {
        border-color: @select-tokens[border-color];
        cursor: pointer;
      }

      select:focus:not(.readonly):not(.disabled) {
        background-position: left bottom;
        background-size: 100% 1px;
      }

      select:valid + label,
      select:focus + label {
        height: 20px;
        line-height: 20px;
        font-size: 11px;
        color: @select-tokens[border-color];
      }
    }
  }
};


// ================================================================ //
// -- Utility Detached Ruleset(s)

@select-transition: {
  .transition(
    @property: border-color, background-size;
    @duration: short
  );
};
